<template>
  <div v-if="role" class="custom-card" style="background-color: white">
    <popup-add-category ref="popupAddCategory" />
    <popup-add-todo ref="popupAddTodo" />
    <div class="vx-row" style="margin: 0 0rem">
      <div class="vx-col w-full lg:w-1/3 todo-list-panel">
        <!--<div class="flex flex-wrap items-center mt-4">
          <vs-button
            @click="$refs.popupAddTodo.show()"
            class="ml-auto mr-auto w-full"
            >Add task</vs-button
          >
        </div>-->
        <vs-input
          icon="search"
          class="mt-3 p-1 w-full"
          placeholder="Search"
          v-on:keypress="onSearch()"
          v-model="query"
        />
        <todo-filter-cards />
        <div class="mt-3 ml-2 p-1">
          <vs-row vs-justify="space-between">
            <span class="text-muted-style text-dark">My lists</span>
            <vx-tooltip
              text="Enable to view todos that has been completed."
              position="top"
            >
              <vs-switch
                v-model="showCompleted"
                @change="toggleShowCompleted"
                vs-icon-off="check_box_outline_blank"
                vs-icon-on="check_box"
              />
            </vx-tooltip>
          </vs-row>
        </div>
        <div style="padding-bottom: 5rem">
          <div class="vertical-menu">
            <a
              v-for="(cat, index) in categories"
              :key="index"
              class="cursor-pointer"
              :class="{ active: categoryIdx === index && !isFiltering }"
              @click="changeCategory(cat, index)"
              ><span class="flex items-center">
                <feather-icon
                  :icon="parseIcon(cat.icon)"
                  :style="{ 'background-color': cat.color }"
                  class="mr-3 p-2 rounded-full text-white"
                  svgClasses="h-4 w-4"
                ></feather-icon>
                <span>{{ cat.name }}</span>
              </span></a
            >
          </div>
        </div>

        <vs-row vs-justify="space-between" class="mb-2">
          <div class="cursor-pointer" @click="$refs.popupAddCategory.show()">
            <span class="flex items-center text-dark text-muted-style">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
              <span>Add List</span>
            </span>
          </div>
          <vs-dropdown class="pull-right text-muted-style cursor-pointer">
            <!-- v-if="roles.length > 1"  -->
            <a class="a-icon" href="#">
              {{ role.title }}
              <vs-icon class="" icon="expand_more"></vs-icon>
            </a>

            <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="(r, index) in roles"
                :key="index"
                :disabled="r.roleId === role.roleId"
                @click="changeRole(index)"
              >
                {{ r.title }}
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </vs-row>
      </div>

      <div class="vx-col flex-1 p-4">
        <todos-list />
        <!--<div class="flex flex-wrap items-center justify-end">
          <vs-button id="save-button" class="ml-auto mt-2"
            >Save Changes</vs-button
          >
        </div>-->
      </div>
    </div>
  </div>
  <div v-else class="h-full flex w-full mt-6 bg-img">
    <div
      class="
        mt-6
        vx-col
        flex
        items-center
        justify-center
        flex-col
        sm:w-1/2
        md:w-3/5
        lg:w-3/4
        xl:w-1/2
        mx-auto
        text-center
      "
    >
      <img
        src="@/assets/images/pages/404.png"
        alt="graphic-404"
        class="mx-auto mb-4 max-w-full"
      />
      <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-text">
        This feature is not for you
      </h1>
      <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text">
        You must have one of the following roles:
        <strong>{{ allowedRoles.join(", ") }}</strong>
      </p>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import moment from "moment";
import TodosList from "./TodosList.vue";
import PopupAddCategory from "./PopupAddCategory.vue";
import TodoFilterCards from "./TodoFilterCards.vue";
import PopupAddTodo from "./PopupAddTodo.vue";

export default {
  components: { PopupAddCategory, TodosList, TodoFilterCards, PopupAddTodo },
  data() {
    return {
      hasLoadedData: false,
    };
  },
  computed: {
    query: {
      get() {
        return this.$store.state.personalTodos.searchQuery;
      },
      set(value) {
        this.$store.commit("personalTodos/setSearchQuery", value);
      },
    },
    ...mapGetters({
      allowedRoles: "personalTodos/allowedRoles",
      showCompleted: "personalTodos/showCompleted",
      activeVenue: "venues/activeVenue",
      categories: "personalTodos/categories",
      category: "personalTodos/category",
      isFiltering: "personalTodos/isFiltering",
      categoryIdx: "personalTodos/categoryIdx",
      userId: "users/userId",
      preferredRole: "users/preferredRole",
      filter: "personalTodos/filter",
      role: "personalTodos/role",
      roles: "personalTodos/roles",
    }),
  },
  methods: {
    parseIcon(icon) {
      if (icon.includes("Icon")) return icon;
      else return icon.charAt(0).toUpperCase() + icon.slice(1) + "Icon";
    },
    onSearch() {
      this.$store.commit("personalTodos/setFilter", "search");
    },
    async toggleShowCompleted(e) {
      if (e.type === "change") {
        await this.$store.dispatch("personalTodos/toggleShowCompleted");
      }
    },
    async changeCategory(cat, idx) {
      await this.$store.dispatch("personalTodos/changeCategory", idx);
      await this.$store.dispatch("personalTodos/changeFilter", "");
    },

    async changeRole(idx) {
      await this.$store.dispatch("personalTodos/setRole", idx);
    },
  },
  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("personalTodos/initializeTodos", {
      venueId: this.activeVenue.venueId,
    });
    await this.$store.dispatch(
      "personalTodos/getUserRoles",
      this.activeVenue.venueId
    );
    if (this.roles.length > 0)
      await this.$store.dispatch("personalTodos/getTodos");
    this.hasLoadedData = true;
    this.$vs.loading.close();
  },
};
</script>


<style  scoped>
.todo-list-panel {
  border-right: 1px solid #ebe9f1;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  max-width: 280px;
}

.custom-card {
  border: 1px solid #ebe9f1;
  border-radius: 0.428rem;
  transition: all 0.3s ease-in-out;
}

.vertical-menu {
  width: 100%;
}

.vertical-menu a {
  display: block;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 8px;
  padding-right: 8px;
  text-decoration: none;
}

.vertical-menu a:hover {
  /*background-color: #ccc;*/
}

.vertical-menu a.active {
  border-radius: 5px;
  background-color: #d9d8d9;
}

.todo-bg-red {
  background-color: #ff443a;
}

.left-bottom {
  position: absolute;
  left: 40px;
  bottom: 35px;
}

.right-bottom {
  position: absolute;
  left: 190px;
  bottom: 39px;
}

.text-muted-style {
  opacity: 0.6;
}
</style>
